module.exports = __webpack_public_path__ + "img/sandwich-1.4a81aacb.jpg";